"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextEllipsis = function (_a) {
    var position = _a.position, text = _a.text, length = _a.length;
    var first = '';
    var middle = '';
    var last = '';
    if (text) {
        switch (position) {
            case 'start':
                first = '...';
                last = text.substring(text.length - length);
                return first + last;
            case 'middle':
                first = text.substring(0, length);
                middle = '...';
                last = text.substring(text.length - length);
                return first + middle + last;
            default:
                first = text.substring(0, length);
                last = '...';
                return first + last;
        }
    }
    return '';
};
exports.default = TextEllipsis;
